import dynamic from 'next/dynamic'
import React from 'react'
import { useLocalization } from '../src/hooks/useLocaleFormatter'
import { Currency } from '../src/model/currency'
import { ProductPriceFragment } from '../src/model/fragments'
import { Spacer } from './Spacer'
import { WidthBound } from './WidthBound'

const priceCentsSubmitLimit = {
	[Currency.CZK]: 1500000,
	[Currency.EUR]: 60000,
}

export interface ShoppingListLayoutProps {
	productList: React.ReactNode
	actions: React.ReactNode
	prices: ProductPriceFragment[]
	submit: React.ReactNode
}

export const ShoppingListLayoutSSR: React.FunctionComponent<ShoppingListLayoutProps> =
	({ productList, actions, prices, submit }) => {
		const localization = useLocalization()
		const isPriceAboveLimit = prices ? (prices.filter(pr => priceCentsSubmitLimit[pr.currency] <= pr.cents).length > 0) : false;
			

		return (
			<WidthBound size="normal" >
				<div className="shoppingListLayout">
					<div className="shoppingListLayout-productList">{productList}</div>
					<div className="shoppingListLayout-actions">
						<div className="shoppingListLayout-actions-in">{actions}</div>
					</div>
					<div className="shoppingListLayout-prices">
						<div className="shoppingListLayout-prices-noVat">
							<div className="shoppingListLayout-prices-label">
								{localization.translate('shoppingList-prices-noVat-label')}
							</div>
							{localization.formatPricesArray(prices).map(p => <div>{p}</div>)}
						</div>
						<div className="shoppingListLayout-prices-vat">
							<div className="shoppingListLayout-prices-label">
								{localization.translate('shoppingList-prices-vat-label')}
							</div>
							{localization.formatPricesArray(prices, 1, true).map(p => <div>{p}</div>)}
						</div>
					</div>
					{isPriceAboveLimit && (
						<div className="shoppingListLayout-submit">{submit}</div>
					)}
				</div>
				<Spacer initial={100} />
			</WidthBound>
		)
	}

export const ShoppingListLayout = dynamic(async () => ShoppingListLayoutSSR, { ssr: false })